import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase/config";
import { useState } from "react";
import { message } from "antd";
//deletes a document
function useDeleteDocument() {
  const [deleteDocLoading, setDeleteDocLoading] = useState(false);

  const deleteDocument = async (collectionName, documentId) => {
    try {
      setDeleteDocLoading(true);
      const docRef = doc(db, collectionName, documentId);
      await deleteDoc(docRef).then(() => {
        message.warning("Entry removed!");
      });
    } catch (error) {
      message.error("Error occurred. Check logs");
      console.log(error);
    } finally {
      setDeleteDocLoading(false);
    }
  };

  return { deleteDocument, deleteDocLoading };
}

export default useDeleteDocument;
